import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../global/default-button/default-button';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { IEventDetailsDTO } from '../../../../../api/events.dao';
import { BulkActionFormPresentation } from './bulk-action-form/bulk-action-form.presentation';
import { BulkActionModalViewModel } from './bulk-action-modal.viewmodel';

interface IProps {
    onCancel: () => void;
    onSubmit: (dates: string[]) => void;
    accountId: number;
    event: IEventDetailsDTO;
    excludeCanceledDates?: boolean;
    requiresConfirmation?: boolean;
    formLabelText?: React.ReactNode;
    modalTitle?: React.ReactNode;
    selectedDatesLabelProps?: { id: string; defaultMessage: string };
    alertMessage?: string;
    alertConfirmButtonText?: React.ReactNode;
}

const BulkActionModalPresentation = mobxReact.observer(({vm}: {vm: BulkActionModalViewModel}) => {
        return (
            <CommonModal
                title={vm.modalTitle}
                isOpen={true}
                onRequestClose={vm.onCancel}
                footer={
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultButton
                            text={
                                <FormattedMessage
                                    description='Button label'
                                    values={{
                                        prefix: vm.getSelectedDates().size
                                    }}
                                    {...vm.selectedDatesLabelProps}
                                />
                            }
                            modifier={['fat', 'confirm-safe']}
                            onClick={vm.openDatesAlert}
                            disabled={!vm.getSelectedDates().size}
                        />
                        <DefaultCloseModalButton text='Go Back' />
                    </div>
                }
            >
                <BulkActionFormPresentation vm={vm} />
            </CommonModal>
        );
    }
);

const BulkActionModalContainer = withViewModel(
    BulkActionModalPresentation,
    (props: IProps) => {
        const {
            accountId,
            event,
            onCancel,
            onSubmit,
            formLabelText,
            modalTitle,
            selectedDatesLabelProps,
            requiresConfirmation,
            excludeCanceledDates,
            alertMessage,
            alertConfirmButtonText
        } = props;
        const bulkActionModalVM = new BulkActionModalViewModel(
            accountId,
            event,
            onCancel,
            onSubmit,
            requiresConfirmation,
            formLabelText,
            modalTitle,
            selectedDatesLabelProps,
            excludeCanceledDates,
            alertMessage,
            alertConfirmButtonText
        );
        bulkActionModalVM.initialize();
        return bulkActionModalVM;
    }
);

export { BulkActionModalContainer as BulkActionModal, BulkActionModalPresentation };
